import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=049b5dbd&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('049b5dbd')) {
      api.createRecord('049b5dbd', component.options)
    } else {
      api.reload('049b5dbd', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=049b5dbd&", function () {
      api.rerender('049b5dbd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hpz7ha947wRJ/JS/imageCarousel.vue"
export default component.exports